import(/* webpackMode: "eager" */ "/opt/natoma/packages/frontend/src/app/home/register/page.tsx");
